module.exports = __webpack_public_path__ + "static/media/cohort1pic2.7019f980.jpg";